import { useMemo } from 'react';
import { CartItem } from '../types/book.types';
import { ViewType } from '../types/view.types';

export interface CartTotals {
    subtotal: number;
    totalWeight: number;
    shippingCost: number;
    discountsTotal: number;
    promoDiscount: number;
    total: number;
}

export function useCartTotals(
    cart: CartItem[], 
    view: ViewType,
    selectedShippingAddress?: any,
    selectedPromo?: any
): CartTotals {
    const subtotal = useMemo(() => cart.reduce((sum, item) => sum + (item.price * item.quantity), 0), [cart]);
    const totalWeight = useMemo(() => cart.reduce((sum, item) => sum + ((item.weight || 0.5) * item.quantity), 0), [cart]);

    const shippingCost = useMemo(() => {
        if (!selectedShippingAddress || cart.length === 0) return 0;
        // Base 5.00€ + 0.50€ por Kg
        return 5.00 + (totalWeight * 0.50);
    }, [selectedShippingAddress, cart, totalWeight]);

    const discountsTotal = useMemo(() => cart.reduce((sum, item) => sum + (item.price * item.quantity * ((item.discount || 0) / 100)), 0), [cart]);

    const promoDiscount = useMemo(() => {
        if (view === 'returns' || !selectedPromo) return 0;
        return (subtotal - discountsTotal) * (selectedPromo.discountPercent / 100);
    }, [subtotal, discountsTotal, selectedPromo, view]);

    const total = subtotal - discountsTotal - promoDiscount + shippingCost;

    return {
        subtotal,
        totalWeight,
        shippingCost,
        discountsTotal,
        promoDiscount,
        total
    };
}
